import React from "react";
import { useTranslation } from "react-i18next";

/**
 * UserTableSkeleton - Loading skeleton for user table
 * Provides visual feedback while data is loading
 */
const UserTableSkeleton: React.FC<{ rows?: number }> = ({ rows = 5 }) => {
  const { t } = useTranslation(["admin"]);

  return (
    <div className="users-table-container">
      <table className="users-table skeleton-table">
        <thead>
          <tr>
            <th>{t("admin:users.table.user")}</th>
            <th>{t("admin:users.table.email")}</th>
            <th>{t("admin:users.table.role")}</th>
            <th>{t("admin:users.table.status")}</th>
            <th>{t("admin:users.table.created")}</th>
            <th>{t("admin:users.table.actions")}</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, index) => (
            <tr key={index} className="skeleton-row">
              <td>
                <div className="user-info">
                  <div
                    className="skeleton-cell"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                    }}
                  />
                  <div style={{ flex: 1 }}>
                    <div
                      className="skeleton-cell"
                      style={{ width: "120px", marginBottom: "4px" }}
                    />
                    <div className="skeleton-cell" style={{ width: "80px" }} />
                  </div>
                </div>
              </td>
              <td>
                <div className="skeleton-cell" style={{ width: "180px" }} />
              </td>
              <td>
                <div
                  className="skeleton-cell"
                  style={{
                    width: "80px",
                    height: "24px",
                    borderRadius: "12px",
                  }}
                />
              </td>
              <td>
                <div
                  className="skeleton-cell"
                  style={{
                    width: "60px",
                    height: "24px",
                    borderRadius: "12px",
                  }}
                />
              </td>
              <td>
                <div className="skeleton-cell" style={{ width: "100px" }} />
              </td>
              <td>
                <div style={{ display: "flex", gap: "8px" }}>
                  <div
                    className="skeleton-cell"
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "6px",
                    }}
                  />
                  <div
                    className="skeleton-cell"
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "6px",
                    }}
                  />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserTableSkeleton;
